export default __webpack_public_path__ + "static/media/upload.a1549f6c.png";